<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">About This Event</h5>
      </div>
    </div>
    <div class="trezo-card-content">
      <p>
        Pellentesque viverra lorem malesuada nunc tristique sapien. Imperdiet
        sit hendrerit tincidunt bibendum donec adipiscing. Tellus non morbi
        nascetur cursus etiam facilisis mi. Dolor aliquam sed amet aliquam
        venenatis. Ac viverra interdum tortor enim. Molestie tincidunt ut
        consequat a urna tortor. Vitae velit ac nisl velit mauris placerat nisi
        placerat.
      </p>
      <p>
        Imperdiet sit hendrerit tincidunt bibendum donec adipiscing. Tellus non
        morbi nascetur cursus etiam facilisis mi. Dolor aliquam sed amet aliquam
        venenatis. Ac viverra interdum tortor enim. Molestie tincidunt ut
        consequat a urna tortor. Vitae velit ac nisl velit mauris placerat nisi
        placerat.
      </p>
      <ul class="mt-[21px]">
        <li class="relative ltr:pl-[15px] rtl:pr-[11px] mb-[11px] last:mb-0">
          <span
            class="absolute w-[6px] h-[6px] rounded-full bg-primary-500 ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></span>
          Pellentesque viverra lorem malesuada nunc tristique sapien.
        </li>
        <li class="relative ltr:pl-[15px] rtl:pr-[11px] mb-[11px] last:mb-0">
          <span
            class="absolute w-[6px] h-[6px] rounded-full bg-primary-500 ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></span>
          Imperdiet sit hendrerit tincidunt bibendum donec adipiscing.
        </li>
        <li class="relative ltr:pl-[15px] rtl:pr-[11px] mb-[11px] last:mb-0">
          <span
            class="absolute w-[6px] h-[6px] rounded-full bg-primary-500 ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></span>
          Tellus non morbi nascetur cursus etiam facilisis mi.
        </li>
        <li class="relative ltr:pl-[15px] rtl:pr-[11px] mb-[11px] last:mb-0">
          <span
            class="absolute w-[6px] h-[6px] rounded-full bg-primary-500 ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 -mt-px"
          ></span>
          Imperdiet sit hendrerit tincidunt bibendum donec adipiscing.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutThisEvent",
};
</script>
